import { Injectable } from '@angular/core';
import { Resolve } from "@angular/router";
import { Observable } from 'rxjs';
import { Crop, CropService } from '../../shared/services/crop.service';
import { ContainerDefinition, ContainerDefinitionService } from '../../shared/services/container-definition.service';
import { Substrate, SubstrateService } from '../../shared/services/substrate.service';
import { Laboratory, LaboratoryService } from '../../shared/services/laboratory.service';
import { GrowthStage, GrowthStageService } from '../../shared/services/growth-stage.service';

@Injectable()
export class ReportingFilterOptionsResolver implements Resolve<ReportingOptions> {
  constructor(
    private cropService: CropService,
    private containerDefinitionService: ContainerDefinitionService,
    private substrateService: SubstrateService,
    private laboratoryService: LaboratoryService,
    private growthStageService: GrowthStageService) { }

  resolve(): Observable<ReportingOptions> {
      return Observable.forkJoin(
        this.cropService.getAll(),
        this.containerDefinitionService.getFlats(),
        this.containerDefinitionService.getPots(),
        this.substrateService.getAll(),
        this.laboratoryService.getAll(),
        this.growthStageService.getAll()
      ).map(
        ([
          crops,
          flats,
          pots,
          substrates,
          laboratories,
          growthStages
        ]) => <ReportingOptions> {
          crops: crops,
          flatContainers: flats,
          potContainers: pots,
          substrates: substrates,
          laboratories: laboratories,
          growthStages: growthStages
        });
  }
}

export interface ReportingOptions {
  crops: Crop[];
  flatContainers: ContainerDefinition[];
  potContainers: ContainerDefinition[];
  substrates: Substrate[];
  laboratories: Laboratory[];
  growthStages: GrowthStage[];
}


// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/reporting/resolvers/reporting-filter-options.resolver.ts